export default {"src":"/_next/static/media/mountain.9ea79a11.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};